export const handleEvent = (handle, eventName, handler, ...handlerArgs) => {
    const handlerWrapper = () => {
        handler(...handlerArgs);
        handle.removeEventListener(eventName, handlerWrapper);
    };
    handle.addEventListener(eventName, handlerWrapper);
};
export async function documentReady() {
    return new Promise((resolve) => {
        if (document.readyState !== "loading") {
            resolve();
        }
        else {
            handleEvent(document, "DOMContentLoaded", resolve);
        }
    });
}
export const htmlToElement = (html) => {
    const template = window.document.createElement("template");
    const trimmedHtml = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = trimmedHtml;
    return template.content.firstChild;
};
//# sourceMappingURL=embedUtils.js.map